<template>
	<app-content class="h-panel">
		
		<router-view/>
	</app-content>
</template>

<script>
	export default {
		name: "propertys",
		data() {
			return {
				
				selected: 'propertys'
			}
		},
		methods: {
			change(data) {
				this.$router.push({name: data.key})
			}
		}
	}
</script>